import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grid from "@material-ui/core/Grid";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import Drawer from "@material-ui/core/Drawer";
import TextField from "@material-ui/core/TextField";
import Helmet from "react-helmet";
import { CheckActionPermission } from "Actions/commonAction";
import headersList from "Constants/headersList";
import Select from "react-select";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";

import { DatePickerComponent } from "../../../../../../Component/Custom";
import { instance } from "../../../../../../Actions/AxiosInstance";
import DrawerHeader from "../../../../../../Component/Headers/drawerHeader";
import { GetMasterData } from "../../../../../../Actions/MasterCodeAction";
import compensatefill from "../../../../../../Assets/Svg/compensatefill.svg";
import compensateget from "../../../../../../Assets/Svg/compensateget.svg";
import {
  getFormattedImageLink,
  getFormattedDate,
  convertDateForBackend,
} from "../../../../../../Utils";
import "./index.css";

class CompensatorDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cmenuopen: false,
      pmenuopen: false,
      drawer: false,
      requestList: [],
      fuelData: [],
      compesatorDetails: [],
      requestCount: 0,
      currentindex: "",
      pastindex: "",
      compesatedList: [],
      noncompesatedList: [],
      selectedComp: null,
      particularRequestDetail: null,
      selectedFuelType: null,
      selectedbanktype: null,
      refid: null,
      compensateddetail: null,
      paymentdate: null,
      comment: null,
      expenserequestid: null,
      expenserequesttypeid: null,
      transactionamount: null,
      button: true,
    };

    this.onMenuPastClick = this.onMenuPastClick.bind(this);
    this.onMenuCurrentClick = this.onMenuCurrentClick.bind(this);
    this.onClickAway = this.onClickAway.bind(this);
    this.getRequestCount = this.getRequestCount.bind(this);
    this.getRequestList = this.getRequestList.bind(this);
    this.compensate = this.compensate.bind(this);
    this.fillForm = this.fillForm.bind(this);
    this.handleClickAway = this.handleClickAway.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getCompensateRequest = this.getCompensateRequest.bind(this);
    this.GetAllBankingDetails = this.GetAllBankingDetails.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("adminDashboard");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getRequestCount();
        if (this.props.AuthenticationAction.login.masterprofileid == 9) {
          this.getCompensatorDetail();
        }
        this.getRequestList();
        // this.GetAllBankingDetails();
        this.getFuelType();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  async getFuelType() {
    const data = await GetMasterData("ExpenseTransactionMode");
    if (data) {
      this.setState({
        fuelData: data.data.result,
      });
    }
  }

  getRequestCount() {
    instance
      .get("expense/compensatordashboard/requestcount/1")
      .then((result) => {
        this.setState({
          requestCount:
            result.data.result[0] && result.data.result[0].requestcount,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getRequestList() {
    instance
      .get("expense/compensatordashboard/request/3")
      .then((result) => {
        const compesatedList = result.data.result.filter(
          (res) => !res.showbutton,
        );
        const noncompesatedList = result.data.result.filter(
          (res) => res.showbutton,
        );
        this.setState({ compesatedList, noncompesatedList });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getCompensateRequest(detail) {
    instance
      .get(
        `expense/compensatordashboard/requestdetail/${detail.expensecompensateid}`,
      )
      .then((result) => {
        this.setState({
          particularRequestDetail: result.data.result[0],
          expenserequestid: detail.expenserequestid,
          expenserequesttypeid: detail.expenserequesttypeid,
          transactionamount: result.data.result[0].transactionamount,
          refid: result.data.result[0].transactionreference,
          paymentdate: result.data.result[0].transactiondate,
          comment: result.data.result[0].comment,
          selectedFuelType: this.state.fuelData.find(
            (fuel) =>
              fuel.displayvalue == result.data.result[0].transactionmodeid,
          ),
          drawer: true,
          button: false,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getCompensatorDetail() {
    instance
      .get("expense/compensatordashboard/compensatordetail")
      .then((result) => {
        this.setState({ compesatorDetails: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  compensate() {
    if (
      !this.state.paymentdate ||
      !this.state.refid ||
      !this.state.selectedFuelType ||
      !this.state.comment
    ) {
      this.props.enqueueSnackbar("Please fill required fields", {
        variant: "error",
      });
    } else if (
      this.state.allBankingDetails &&
      this.state.allBankingDetails.length == 0
    ) {
      this.props.enqueueSnackbar("Please add bank account of employee", {
        variant: "error",
      });
    } else if (
      this.state.selectedFuelType &&
      this.state.selectedFuelType.displayvalue == 3 &&
      !this.state.selectedbanktype
    ) {
      this.props.enqueueSnackbar("Please fill required fields", {
        variant: "error",
      });
    } else {
      const data = {
        expenserequestid: this.state.expenserequestid,
        actionid: 2,
        expenserequesttypeid: this.state.expenserequesttypeid,
        transactionamount: this.state.transactionamount,
        transactionmodeid:
          this.state.selectedFuelType &&
          this.state.selectedFuelType.displayvalue,
        employeebankid:
          this.state.selectedbanktype &&
          this.state.selectedbanktype.displayvalue,
        transactionreference: this.state.refid,
        comment: this.state.comment,
        transactiondate: convertDateForBackend(this.state.paymentdate),
      };
      instance
        .post("expense/compensatordashboard/actionrequest", data)
        .then(() => {
          this.props.enqueueSnackbar("Save successfully", {
            variant: "success",
          });
          this.getRequestList();
          this.getRequestCount();
          this.setState({
            drawer: false,
            selectedFuelType: null,
            selectedbanktype: null,
            transactionamount: null,
            refid: null,
            expenserequestid: null,
            expenserequesttypeid: null,
            comment: null,
            paymentdate: null,
            particularRequestDetail: null,
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  GetAllBankingDetails() {
    const URL = "employee/getempallbankdetail";
    const data = {
      accountid: this.props.AuthenticationAction.login.accountid,
      subscriptionid: this.props.AuthenticationAction.login.subscriptionid,
      timezoneid: this.props.AuthenticationAction.login.countrytimezoneid,
      employeeid: this.state.compensateddetail.employeeid,
    };
    instance
      .post(URL, data)
      .then((result) => {
        console.log("result.data.result: ", result.data.result);
        this.setState({
          allBankingDetails: result.data.result.map((element) => ({
            displayvalue: element.employeebankid,
            displayname: `${element.bankname} [${element.accountnumber}]`,
          })),
        });
      })
      // })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  handleChange(name, value) {
    console.log("value: ", value);
    console.log("name: ", name);
    if (name == "selectedFuelType" && value.displayvalue == 3) {
      this.GetAllBankingDetails();
    }
    this.setState({
      [name]: value,
    });
  }

  fillForm(detail) {
    console.log("detail: ", detail);
    this.setState({
      compensateddetail: detail,
      drawer: true,
      expenserequesttypeid: detail && detail.expenserequesttypeid,
      expenserequestid: detail && detail.expenserequestid,
      transactionamount: detail && detail.transactionamount,
      button: true,
    });
  }

  onMenuCurrentClick(selectedComp, index) {
    this.setState({
      cmenuopen: true,
      pmenuopen: false,
      selectedComp,
      currentindex: index,
      pastindex: "",
    });
  }

  onMenuPastClick(selectedComp, index) {
    this.setState({
      cmenuopen: false,
      pmenuopen: true,
      selectedComp,
      pastindex: index,
      currentindex: "",
    });
  }

  onClickAway() {
    this.setState({
      cmenuopen: false,
      pmenuopen: false,
      currentindex: "",
      pastindex: "",
      selectedComp: null,
    });
  }

  handleClickAway() {
    this.setState({
      drawer: false,
      selectedFuelType: null,
      transactionamount: null,
      refid: null,
      expenserequestid: null,
      expenserequesttypeid: null,
      comment: null,
      paymentdate: null,
    });
  }

  render() {
    return (
      <div className="content-outer-wrapper-with-tab">
        <Helmet>
          <title>{headersList.Expense.Compensator.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            <Grid container>
              <Grid item xs={12} md={12} sm={12}>
                <div className="floatleft">
                  <span className="page-header-name">
                    Compensator Dashboard
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} md={12} sm={12}>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    sm={10}
                    className="padding-right-24 padding-bottom-24"
                  >
                    <div className="pending-request border-bottom-light">
                      <p className="input-label">Pending Compensate Request</p>
                      <span className="t-bold">
                        {this.state.requestCount} Requests
                      </span>
                    </div>
                    {this.props.AuthenticationAction.login.masterprofileid ==
                      9 &&
                      this.state.compesatorDetails.length > 0 &&
                      this.state.compesatorDetails[0].current.length > 0 && (
                        <div className="border-bottom-light margin-bottom-24 margin-top-24 padding-bottom-24">
                          <p className="input-label">Current Compensator</p>
                          <div className="profile-thumb-wrapper">
                            {this.state.compesatorDetails.length > 0 &&
                              this.state.compesatorDetails[0].current.length >
                                0 &&
                              this.state.compesatorDetails[0].current.map(
                                (comp, index) => (
                                  <div
                                    key={index}
                                    className={
                                      index == this.state.currentindex &&
                                      this.state.cmenuopen
                                        ? "profile-thumb-img-with-border"
                                        : "profile-thumb-img"
                                    }
                                    onClick={() =>
                                      this.onMenuCurrentClick(comp, index)
                                    }
                                  >
                                    <img
                                      src={
                                        comp.imagepath
                                          ? getFormattedImageLink(
                                              comp.imagepath,
                                            )
                                          : DefaultProfileImage
                                      }
                                    />
                                    {index == this.state.currentindex &&
                                      this.state.cmenuopen && (
                                        <i className="material-icons floatleft down-arrow-indicator">
                                          keyboard_arrow_down
                                        </i>
                                      )}
                                  </div>
                                ),
                              )}
                          </div>
                        </div>
                      )}
                    {this.props.AuthenticationAction.login.masterprofileid ==
                      9 &&
                      this.state.compesatorDetails.length > 0 &&
                      this.state.compesatorDetails[0].past.length > 0 && (
                        <div className="margin-top-24 padding-bottom-24">
                          <p className="input-label">Past Compensator</p>
                          <div className="profile-thumb-wrapper-with-border">
                            {this.state.compesatorDetails.length > 0 &&
                              this.state.compesatorDetails[0].past.length > 0 &&
                              this.state.compesatorDetails[0].past.map(
                                (comp, index) => (
                                  <div
                                    key={index}
                                    className={
                                      index == this.state.pastindex &&
                                      this.state.pmenuopen
                                        ? "profile-thumb-img-with-border"
                                        : "profile-thumb-img"
                                    }
                                    onClick={() =>
                                      this.onMenuPastClick(comp, index)
                                    }
                                  >
                                    <img
                                      src={
                                        comp.imagepath
                                          ? getFormattedImageLink(
                                              comp.imagepath,
                                            )
                                          : DefaultProfileImage
                                      }
                                    />
                                    {index == this.state.pastindex &&
                                      this.state.pmenuopen && (
                                        <i className="material-icons floatleft down-arrow-indicator">
                                          keyboard_arrow_down
                                        </i>
                                      )}
                                  </div>
                                ),
                              )}
                            <div className="clear-float"></div>
                          </div>
                        </div>
                      )}
                    <Popper
                      open={this.state.cmenuopen}
                      anchorEl={this.anchorEl}
                      placement="right"
                      transition
                      disablePortal
                      style={{
                        zIndex: 1111,
                        width: "23vw",
                        position: "relative",
                        top: -108,
                      }}
                      className="biometric-poper"
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === "top"
                                ? "center top"
                                : "center bottom",
                          }}
                        >
                          <Paper className="padding16">
                            <ClickAwayListener onClickAway={this.onClickAway}>
                              <div>
                                {this.state.selectedComp && (
                                  <Grid container>
                                    <div className="dashed-border-bottom-light width100">
                                      <span>
                                        {this.state.selectedComp &&
                                          this.state.selectedComp.fullname}
                                      </span>
                                      <p className="input-label">
                                        {this.state.selectedComp &&
                                          this.state.selectedComp
                                            .effectivefrom &&
                                          getFormattedDate(
                                            this.state.selectedComp
                                              .effectivefrom,
                                          )}
                                      </p>
                                      <p className="input-label">
                                        Total Compensated Money
                                      </p>
                                      <p className="t-bold">
                                        INR{" "}
                                        {this.state.selectedComp &&
                                          this.state.selectedComp.totalamount &&
                                          this.state.selectedComp.totalamount}
                                      </p>
                                    </div>
                                    <div
                                      className="width100 margin-top-16 thin-scroll"
                                      style={{ height: 204, overflowY: "auto" }}
                                    >
                                      {this.state.selectedComp &&
                                        this.state.selectedComp.access &&
                                        this.state.selectedComp.access
                                          .businessunit && (
                                          <div>
                                            <div className="floatleft width40">
                                              <span className="extra-small-dark-secondary t-bold display-block">
                                                Business unit
                                              </span>
                                            </div>
                                            <div className="floatright width60">
                                              {this.state.selectedComp &&
                                                this.state.selectedComp
                                                  .access &&
                                                this.state.selectedComp.access
                                                  .businessunit &&
                                                this.state.selectedComp.access.businessunit.map(
                                                  (bu) => (
                                                    <span
                                                      key="d"
                                                      className="display-block text-copy"
                                                    >
                                                      {bu.businessunitname}
                                                    </span>
                                                  ),
                                                )}
                                            </div>
                                          </div>
                                        )}
                                      <div className="clear-float"></div>
                                      {this.state.selectedComp &&
                                        this.state.selectedComp.access &&
                                        this.state.selectedComp.access
                                          .department && (
                                          <div>
                                            <div className="floatleft width40">
                                              <span className="extra-small-dark-secondary t-bold display-block">
                                                Department
                                              </span>
                                            </div>
                                            <div className="floatright width60">
                                              {this.state.selectedComp &&
                                                this.state.selectedComp
                                                  .access &&
                                                this.state.selectedComp.access
                                                  .department &&
                                                this.state.selectedComp.access.department.map(
                                                  (bu) => (
                                                    <span
                                                      key="d"
                                                      className="display-block text-copy"
                                                    >
                                                      {bu.departmentname}
                                                    </span>
                                                  ),
                                                )}
                                            </div>
                                          </div>
                                        )}
                                      <div className="clear-float"></div>
                                      {this.state.selectedComp &&
                                        this.state.selectedComp.access &&
                                        this.state.selectedComp.access
                                          .location && (
                                          <div>
                                            <div className="floatleft width40">
                                              <span className="extra-small-dark-secondary t-bold display-block">
                                                Location
                                              </span>
                                            </div>
                                            <div className="floatright width60">
                                              {this.state.selectedComp &&
                                                this.state.selectedComp
                                                  .access &&
                                                this.state.selectedComp.access
                                                  .location &&
                                                this.state.selectedComp.access.location.map(
                                                  (bu) => (
                                                    <span
                                                      key="d"
                                                      className="display-block text-copy"
                                                    >
                                                      {bu.locationname}
                                                    </span>
                                                  ),
                                                )}
                                            </div>
                                          </div>
                                        )}
                                      <div className="clear-float"></div>
                                    </div>
                                  </Grid>
                                )}
                              </div>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                    <Popper
                      open={this.state.pmenuopen}
                      anchorEl={this.anchorEl}
                      placement="right"
                      transition
                      disablePortal
                      style={{
                        zIndex: 1111,
                        width: "23vw",
                        position: "relative",
                        top: -8,
                      }}
                      className="biometric-poper"
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === "top"
                                ? "center top"
                                : "center bottom",
                          }}
                        >
                          <Paper className="padding16">
                            <ClickAwayListener onClickAway={this.onClickAway}>
                              <div>
                                {this.state.selectedComp && (
                                  <Grid container>
                                    <div className="dashed-border-bottom-light width100">
                                      <span>
                                        {this.state.selectedComp &&
                                          this.state.selectedComp.fullname}
                                      </span>
                                      <p className="input-label">
                                        {this.state.selectedComp &&
                                          this.state.selectedComp
                                            .effectivefrom &&
                                          getFormattedDate(
                                            this.state.selectedComp
                                              .effectivefrom,
                                          )}
                                      </p>
                                      <p className="input-label">
                                        Total Compensated Money
                                      </p>
                                      <p className="t-bold">
                                        INR{" "}
                                        {this.state.selectedComp &&
                                          this.state.selectedComp.totalamount &&
                                          this.state.selectedComp.totalamount}
                                      </p>
                                    </div>
                                    <div
                                      className="width100 margin-top-16 thin-scroll"
                                      style={{ height: 204, overflowY: "auto" }}
                                    >
                                      {this.state.selectedComp &&
                                        this.state.selectedComp.access &&
                                        this.state.selectedComp.access
                                          .businessunit && (
                                          <div>
                                            <div className="floatleft width40">
                                              <span className="extra-small-dark-secondary t-bold display-block">
                                                Business unit
                                              </span>
                                            </div>
                                            <div className="floatright width60">
                                              {this.state.selectedComp &&
                                                this.state.selectedComp
                                                  .access &&
                                                this.state.selectedComp.access
                                                  .businessunit &&
                                                this.state.selectedComp.access.businessunit.map(
                                                  (bu) => (
                                                    <span
                                                      key="d"
                                                      className="display-block text-copy"
                                                    >
                                                      {bu.businessunitname}
                                                    </span>
                                                  ),
                                                )}
                                            </div>
                                          </div>
                                        )}
                                      <div className="clear-float"></div>
                                      {this.state.selectedComp &&
                                        this.state.selectedComp.access &&
                                        this.state.selectedComp.access
                                          .department && (
                                          <div>
                                            <div className="floatleft width40">
                                              <span className="extra-small-dark-secondary t-bold display-block">
                                                Department
                                              </span>
                                            </div>
                                            <div className="floatright width60">
                                              {this.state.selectedComp &&
                                                this.state.selectedComp
                                                  .access &&
                                                this.state.selectedComp.access
                                                  .department &&
                                                this.state.selectedComp.access.department.map(
                                                  (bu) => (
                                                    <span
                                                      key="d"
                                                      className="display-block text-copy"
                                                    >
                                                      {bu.departmentname}
                                                    </span>
                                                  ),
                                                )}
                                            </div>
                                          </div>
                                        )}
                                      <div className="clear-float"></div>
                                      {this.state.selectedComp &&
                                        this.state.selectedComp.access &&
                                        this.state.selectedComp.access
                                          .location && (
                                          <div>
                                            <div className="floatleft width40">
                                              <span className="extra-small-dark-secondary t-bold display-block">
                                                Location
                                              </span>
                                            </div>
                                            <div className="floatright width60">
                                              {this.state.selectedComp &&
                                                this.state.selectedComp
                                                  .access &&
                                                this.state.selectedComp.access
                                                  .location &&
                                                this.state.selectedComp.access.location.map(
                                                  (bu) => (
                                                    <span
                                                      key="d"
                                                      className="display-block text-copy"
                                                    >
                                                      {bu.locationname}
                                                    </span>
                                                  ),
                                                )}
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </Grid>
                                )}
                              </div>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={8}
                    sm={2}
                    className="compensated-details"
                  >
                    {this.state.noncompesatedList.map((details) => (
                      <div key="details" className="margin-bottom-16">
                        <Paper className="padding16">
                          <Grid container>
                            <Grid item xs={12} md={1} sm={12}>
                              <div
                                className="profile-thumb"
                                style={{ marginTop: 5 }}
                              >
                                <img
                                  src={
                                    details.imagepath
                                      ? getFormattedImageLink(details.imagepath)
                                      : DefaultProfileImage
                                  }
                                />
                              </div>
                            </Grid>
                            <Grid item xs={12} md={3} sm={12}>
                              <div>
                                <span className="margin-right-16 small-dark t-bold">
                                  {details.fullname}
                                </span>
                              </div>
                              <div className="margin-top-8">
                                <span className="small-dark-secondary">
                                  {details.updateddate &&
                                    getFormattedDate(details.updateddate)}
                                </span>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4} sm={12}>
                              <div>
                                <span className="small-dark margin-right-16 t-bold">
                                  {
                                    this.props.SubscriptionInfo.SubscriptionData
                                      .currencycode
                                  }{" "}
                                  {details.transactionamount}
                                </span>
                              </div>
                              <div>
                                <span className="small-dark-secondary margin-right-16">
                                  {details.expenserequesttypename}
                                </span>
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={4}
                              sm={12}
                              className="text-align-center"
                            >
                              <div>
                                <div className="compensate-dr-outer floatleft">
                                  <div className="small-dark-secondary ">
                                    Pending for compensation
                                  </div>
                                </div>
                                {/* {this.state.permissions &&
                              this.state.permissions.editable && ( */}
                                <div
                                  className="cursor-pointer"
                                  onClick={() => this.fillForm(details)}
                                >
                                  <div style={{ marginTop: 5 }}>
                                    <img
                                      src={compensatefill}
                                      alt=""
                                      height="32"
                                    />
                                  </div>
                                </div>
                                {/* )} */}
                                <div className="clearfloat"></div>
                              </div>
                            </Grid>
                          </Grid>
                        </Paper>
                      </div>
                    ))}
                    <div
                      style={{
                        borderTop: "4px solid #edf5fd",
                        margin: "16px 0px",
                      }}
                    ></div>
                    {this.state.compesatedList.map((details) => (
                      <div key="details" className="margin-bottom-16">
                        <Paper className="padding16">
                          <Grid container>
                            <Grid item xs={12} md={1} sm={12}>
                              <div
                                className="profile-thumb"
                                style={{ marginTop: 5 }}
                              >
                                <img
                                  src={
                                    details.imagepath
                                      ? getFormattedImageLink(details.imagepath)
                                      : DefaultProfileImage
                                  }
                                />
                              </div>
                            </Grid>
                            <Grid item xs={12} md={3} sm={12}>
                              <div>
                                <span className="margin-right-16 small-dark t-bold">
                                  {details.fullname}
                                </span>
                              </div>
                              <div className="margin-top-8">
                                <span className="small-dark-secondary">
                                  {details.updateddate &&
                                    getFormattedDate(details.updateddate)}
                                </span>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4} sm={12}>
                              <div>
                                <span className="small-dark margin-right-16 t-bold">
                                  {
                                    this.props.SubscriptionInfo.SubscriptionData
                                      .currencycode
                                  }{" "}
                                  {details.transactionamount}
                                </span>
                              </div>
                              <div>
                                <span className="small-dark-secondary margin-right-16">
                                  {details.expenserequesttypename}
                                </span>
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={4}
                              sm={12}
                              className="text-align-center"
                            >
                              {!details.showbutton && details.compensatedon ? (
                                <div className="compensate-dr-outer width80 floatright">
                                  <div className="floatleft">
                                    <div className="small-dark-secondary">
                                      Compensated by
                                    </div>
                                    <div className="small-dark">
                                      <span>{details.compensatorname}</span>
                                    </div>
                                  </div>
                                  <div
                                    className="cursor-pointer"
                                    onClick={() =>
                                      this.getCompensateRequest(details)
                                    }
                                  >
                                    <img
                                      src={compensateget}
                                      alt=""
                                      height="32"
                                    />
                                  </div>
                                  <div className="clearfloat"></div>
                                </div>
                              ) : (
                                <div className="compensate-dr-outer">
                                  <div className="small-dark-secondary ">
                                    Pending for compensation
                                  </div>
                                </div>
                              )}
                            </Grid>
                          </Grid>
                        </Paper>
                      </div>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Drawer
              anchor="right"
              open={this.state.drawer}
              onClose={this.handleClickAway}
              style={{ padding: 40, width: 300 }}
              classes={{
                paper: "drawer-comp padding15",
              }}
            >
              <DrawerHeader
                header={
                  this.state.button ? "Compensate request" : "Compensated info"
                }
                isbackarrow={false}
                closeDrawer={this.handleClickAway}
              />
              <div>
                <p>
                  <div className="extra-small-blue" style={{ marginTop: 16 }}>
                    Payment mode
                  </div>
                  {this.state.button ? (
                    <Select
                      className="select-multiple width100"
                      onChange={(event) =>
                        this.handleChange("selectedFuelType", event)
                      }
                      options={this.state.fuelData}
                      getOptionLabel={(option) =>
                        option.displayname || option.fullname
                      }
                      getOptionValue={(option) =>
                        option.displayvalue || option.employeeid
                      }
                      value={this.state.selectedFuelType}
                    />
                  ) : (
                    <div>
                      {this.state.selectedFuelType &&
                        this.state.selectedFuelType.displayname}
                    </div>
                  )}
                </p>
                {this.state.button &&
                  this.state.selectedFuelType &&
                  this.state.selectedFuelType.displayvalue == 3 && (
                    <p>
                      <div
                        className="extra-small-blue"
                        style={{ marginTop: 16 }}
                      >
                        Employee's bank account
                      </div>
                      <Select
                        className="select-multiple width100"
                        onChange={(event) =>
                          this.handleChange("selectedbanktype", event)
                        }
                        options={this.state.allBankingDetails}
                        getOptionLabel={(option) =>
                          option.displayname || option.fullname
                        }
                        getOptionValue={(option) =>
                          option.displayvalue || option.employeeid
                        }
                        value={this.state.selectedbanktype}
                      />
                    </p>
                  )}
                <p>
                  <div className="extra-small-blue">
                    Transfer ID / Reference No.
                  </div>
                  {this.state.button ? (
                    <TextField
                      className="remark-input margin-top-4 margin-bottom-4 width100"
                      onChange={(event) =>
                        this.handleChange("refid", event.target.value)
                      }
                      value={this.state.refid}
                      id="outlined-bare"
                      type="text"
                      margin="normal"
                      variant="outlined"
                    />
                  ) : (
                    <div>{this.state.refid}</div>
                  )}
                </p>
                <p>
                  <div className="extra-small-blue">Select payment date</div>
                  {this.state.button ? (
                    <DatePickerComponent
                      onChange={(event) =>
                        this.handleChange("paymentdate", event.value)
                      }
                      value={this.state.paymentdate}
                    />
                  ) : (
                    <div>{getFormattedDate(this.state.paymentdate)}</div>
                  )}
                </p>
                <p>
                  <div className="extra-small-blue">Remarks</div>
                  {this.state.button ? (
                    <TextField
                      className="remark-input margin-top-4 margin-bottom-4 width100"
                      onChange={(event) =>
                        this.handleChange("comment", event.target.value)
                      }
                      value={this.state.comment}
                      id="outlined-bare"
                      type="text"
                      margin="normal"
                      variant="outlined"
                    />
                  ) : (
                    <div>{this.state.comment}</div>
                  )}
                </p>
                <div>
                  {this.state.button && (
                    <Button
                      className="btn btn-primary-sm-blue"
                      onClick={() => this.compensate()}
                    >
                      Compensate
                    </Button>
                  )}
                </div>
              </div>
            </Drawer>
          </div>
        )}
      </div>
    );
  }
}

CompensatorDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles()(withSnackbar(CompensatorDashboard)));
